import moment from "moment";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router";
import { useMediaQuery } from "react-responsive";

import { OrderGroupContainer } from "../component/styled";

import { productStatus, renderProductInfo, status } from "../../common/function/shopping";

const OrderGroup = ({
  item,
  isDetail = false,
  openModal,
  closeModal,
  toggleModal = null,
  getData = null,
}) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);
  const { url } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const handleCart = async (product) => {
    const body = {
      input: {
        mberNo: user?.mberNo,
        platform: "MULTI_PAGE",
        vendorProductId: product.productId,
        quantity: product.quantity,
        checked: true,
        options: product.options.map((opt) => ({
          optionId: opt.optionId,
          qty: opt.quantity,
          name: opt.optionValue,
          price: opt.addPrice,
          optionGroupName: opt.optionGroupName,
        })),
      },
    };

    try {
      const res = await axios.post("/erp/cart/upsert", body);
      if (res.status === 200) {
        openModal({
          type: "confirmation",
          title: "장바구니 이동",
          message: ["상품이 장바구니에 담겼습니다.", "장바구니로 이동하시겠습니까?"],
          handleConfirm: () => {
            closeModal();
            navigate(`/shop/mypage/cart`);
          },
          handleCancel: closeModal,
        });
      }
    } catch {
      console.error("잠시후 다시 시도해주세요");
    }
  };

  const getActionButtonLabel = (status) => {
    if (["ORDERED", "CONFIRMED", "PREPARING"].includes(status)) return "주문 취소";
    if (["DELIVERED", "COMPLETED", "SHIPPED"].includes(status)) return "교환/반품 신청";
    return null;
  };

  const getDomain = async (cmpnyNo) => {
    const url = "/api/domainSettingLoad";
    const body = { cmpnyNo, delYn: "N" };

    try {
      const res = await axios.post(url, body);
      const domain = res?.data?.domain;
      if (domain) {
        return domain;
      }
    } catch (error) {
      return null;
    }
  };

  const goCompany = async (cmpnyNo, path) => {
    const domain = await getDomain(cmpnyNo);
    if (domain) {
      navigate(`/shop/${domain}${path}`);
    } else {
      console.error("도메인 정보를 가져오지 못했습니다.");
    }
  };

  const renderActionButtons = (product, company) => {
    const status = product?.delivery?.deliveryStatus ?? "";

    const buttons = [
      !isMobile && (
        <button key="cart" onClick={() => handleCart(product)}>
          장바구니 담기
        </button>
      ),
    ];

    const actionsByStatus = {
      PENDING: [
        {
          key: "cancel",
          label: "주문 취소",
          // onClick: () => toggleModal(company, "cancel"),
          onClick: () => alert("준비중입니다."),
        },
      ],
      IN_TRANSIT: [
        {
          key: "track",
          label: "배송조회",
          onClick: () => navigate(`/shop/mypage/history/${item.id}/delivery`),
        },
        {
          key: "exchange",
          label: "교환/반품 신청",
          // onClick: () => toggleModal(company, "exchange"),
          onClick: () => alert("준비중입니다."),
        },
      ],
      DELIVERED: [
        {
          key: "exchange",
          label: "교환/반품 신청",
          // onClick: () => toggleModal(company, "exchange"),
        },
        {
          key: "review",
          label: "리뷰 작성",
          // onClick: () => navigate(`/shop/mypage/review/${product.productId}`),
        },
      ],
    };

    const extra = actionsByStatus[status] || [];
    extra.forEach(({ key, label, onClick }) =>
      buttons.push(
        <button key={key} onClick={onClick}>
          {label}
        </button>,
      ),
    );

    return buttons;
  };

  return (
    <OrderGroupContainer as={isDetail ? "div" : "li"}>
      <div className="orderInfo">
        <p>
          <strong>{moment(item.createdAt).format("YYYY.MM.DD")}</strong>
          {isDetail && <span>주문번호 {item.orderId}</span>}
        </p>
        {!isDetail && (
          <button onClick={() => navigate(`/shop/mypage/history/${item.id}`)}>주문상세보기</button>
        )}
      </div>

      <div className="companies">
        {item.subOrders.map((company) => {
          const actionLabel = getActionButtonLabel(company.status);

          return (
            <div className="company">
              <div className="companyName">
                <span onClick={() => goCompany(company.cmpnyNo, "/productsList")}>
                  {company.cmpnyName}
                </span>
                <span className={company?.status ? company.status.toLowerCase() : ""}>
                  {status[company.status]}
                </span>
              </div>
              <ul>
                {company.products.map((product) => {
                  const buttons = renderActionButtons(product, company);
                  return (
                    <li>
                      <div className="content">
                        <div className="deliveryInfo">
                          <span className="status">
                            {productStatus[product?.delivery?.deliveryStatus]}
                          </span>
                          {product?.delivery?.updatedAt && (
                            <>
                              <i></i>
                              <span className="date">
                                {moment(product?.delivery?.updatedAt).format("YYYY-MM-DD")}
                              </span>
                            </>
                          )}
                        </div>
                        {isMobile && (
                          <button key="cart" onClick={() => handleCart(product)}>
                            장바구니 담기
                          </button>
                        )}
                        <img
                          src={imgHandler(product?.media || "")}
                          alt={product.productName}
                          onError={(e) => (e.target.src = "/img/icon_function_3.png")}
                        />
                        <div className="info">
                          {renderProductInfo(product, () =>
                            goCompany(company.cmpnyNo, `/productsView/${product.productId}`),
                          )}
                        </div>
                      </div>
                      {buttons.length > 0 && <div className="actions">{buttons}</div>}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </OrderGroupContainer>
  );
};

export default OrderGroup;
